import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Attendee } from '../types';
//
// Список всех участников, с которыми можем назначать встречи
//
export type AttendeesState = Attendee[];
const initialState = [] as AttendeesState; 

export const attendeesSlice = createSlice({
    name: 'attendees',
    initialState,
    reducers: {
        attendeesSet: (state, action: PayloadAction<AttendeesState>) => {
            return action.payload;
        },
    }
});

export const { attendeesSet } = attendeesSlice.actions;
export default attendeesSlice.reducer;
